import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/storage'
import 'firebase/analytics'
import 'firebase/functions'

const firebaseConfig = {
    apiKey: process.env.REACT_APP_API_KEY,
    authDomain: process.env.REACT_APP_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_DATABASE_URL,
    projectId: process.env.REACT_APP_PROJECT_ID,
    storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_ID,
    measurementId: process.env.REACT_APP_MEASUREMENT_ID,
}

// Only initialize Firebase if we have the required config values
// This prevents build errors when environment variables are not set
if (firebaseConfig.apiKey && firebaseConfig.projectId) {
    // Check if Firebase is already initialized (prevents duplicate initialization errors)
    if (!firebase.apps.length) {
        firebase.initializeApp(firebaseConfig)
    }

    // Initialize Analytics (only in browser)
    if (typeof window !== 'undefined' && firebaseConfig.measurementId) {
        try {
            firebase.analytics()
        } catch (error) {
            // Analytics initialization can fail in some environments, log but don't throw
            console.warn('Firebase Analytics initialization failed:', error)
        }
    }
} else {
    console.warn(
        'Firebase configuration is missing. Please set REACT_APP_API_KEY and REACT_APP_PROJECT_ID environment variables.'
    )
}

export default firebase
